export function trackPublicFeatureEvent(name, properties = {}) {
  try {
    if (typeof window !== "undefined" && window.posthog?.capture) {
      window.posthog.capture(name, properties);
    }
  } catch {
    // Optional analytics must never interrupt a public page.
  }
}
